module.exports = __webpack_public_path__ + "static/veniki-d9918e4e49bd8649ee146860c2eba9da.webp";